/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditBatchResponse {
    getFixupPrototypeFunction() { return RequestAuditBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditBatchResponse>): RequestAuditBatchResponse {
        let obj = Object.assign(new RequestAuditBatchResponse(), model);
        RequestAuditBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditBatchResponse>): RequestAuditBatchResponse {
        if (!model) return null;
        return RequestAuditBatchResponse.newInstance(<RequestAuditBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditBatchResponse) {
        if (!obj) return;

        models.RequestAuditBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditBatchResponse): boolean {
        Object.setPrototypeOf(obj, RequestAuditBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.RequestAuditEntry.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.RequestAuditEntry; };

}
